export default "__VITE_ASSET__vjVG25y2__"